module.exports = __webpack_public_path__ + "static/media/teamwork.6262aa61.png";